import { Stage } from '@gmp/shared-ui';
import { party } from '../net/client';
import { navigate } from '../app/router';
import { Mascot } from '../app/Mascot';

export function Waiting({ code }: { code: string }) {
  return (
    <Stage>
      <main className="flex-1 grid place-items-center p-6 text-center">
        <div className="flex flex-col items-center gap-4">
          <Mascot pose="peek" size={180} />
          <h1 className="font-display font-black text-3xl">Knock knock</h1>
          <p className="text-mute">Waiting for the host of <b className="font-display tracking-widest">{code}</b> to let you in.</p>
          <button className="btn btn-ghost btn-sm" onClick={() => { party.leave(); navigate({ name: 'home' }, true); }}>Cancel</button>
        </div>
      </main>
    </Stage>
  );
}
